import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import MoodCard from "../components/MoodCard"
import moodData from "../assets/data/moodData"
import Button from "../components/Button"
import { API_URL } from "../config/api"
import { logError, formatError } from "../services/logging"

const Questionnaire = () => {
  const [moodValues, setMoodValues] = useState(
    Object.fromEntries(moodData.map(mood => [mood.mood, null]))
  )
  const [activeMood, setActiveMood] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const checkMoodSubmission = async () => {
      try {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
        const resp = await fetch(`${API_URL}/api/mood_entries/today?timezone=${userTimezone}`, {
          method: 'GET',
          credentials: "include"
        })

        // if (!resp.ok) {
        //   toast.error("Unable to verify today's submission. Please try again.")
        //   return
        // }

        const data = await resp.json()

        if (data.hasSubmittedToday) {
          navigate('/prompts')
        }
      } catch (error) {
        toast.error("Unable to check mood submission status. Please try again.")
      }
    }
    checkMoodSubmission()
  }, [navigate])

  const handleSliderChange = (mood, val) => {
    setMoodValues(prev => (
      {
        ...prev,
        [mood.mood]: val,
      }
    ))
  }

  const lowercaseKeys = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== null) {
        acc[key.toLowerCase()] = obj[key]
      }
      return acc
    }, {})
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const lowercaseMoodValues = lowercaseKeys(moodValues)
    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
      const resp = await fetch(`${API_URL}/api/mood_entries?timezone=${userTimezone}`, {
        method: 'POST',
        headers: {
          "Content-Type": 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(lowercaseMoodValues)
      })
      const data = await resp.json()
      if (resp.ok) {
        toast.success("Mood entry saved, let’s explore today’s prompts.")
        navigate('/prompts')
      } else {
        logError(data)
        toast.error(data.message || "Failed to save mood entry. Please try again.")
      }
    } catch (error) {
      logError(formatError(error))
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  const mappedMoods = moodData.map(mood => (
    <MoodCard 
      key={mood.mood} 
      {...mood} 
      value={moodValues[mood.mood]}
      onSliderChange={(val) => handleSliderChange(mood, val)} 
      activeMood={activeMood}
      setActiveMood={setActiveMood}
    />
  ))

  return (
    <div className="container">
      <h2>Take a mindful moment to check in with your feelings.</h2>
      <p>
        Choose how you’re feeling today by sliding the bar for each emotion. Take your time—your mood is unique, and there’s no right or wrong way to rate it.
      </p>
      <form onSubmit={handleSubmit}>
        <section className="grid">
          {mappedMoods}
        </section>
        <Button variant="accent" text="Continue" type="submit" />
      </form>
    </div>
  )
}

export default Questionnaire